var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-stretch gap-2"},[_c('JoszakiButton',{attrs:{"type":"info","inverted":"","outline":"","to":_vm.localePath({
        name: 'professionalRatingPage',
        params: {
          professionalSeoName: _vm.person.seoName,
        },
      })}},[_vm._v(" "+_vm._s(_vm.$t("profileAction.rateMate"))+" ")]),_c('JoszakiButton',{attrs:{"type":"danger","inverted":"","outline":""},on:{"click":_vm.reportPerson}},[_vm._v(" "+_vm._s(_vm.$t("profileAction.reportMate"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }